<template>
  <div class="flex">
    <div class="title">
      <p>
        公開日<span class="c-text--accent c-text--normal c-text-13"
          >（任意）</span
        >
      </p>
    </div>
    <div class="form c-alertPos">
      <DatePicker
        v-model="params.publishedDate"
        :max-date="null"
        :disabled="isDisabled"
      />
      <Alert v-if="hasGetError">
        公開日を取得できませんでした。ページを再読み込みしてください
      </Alert>
    </div>
    <div class="btnArea">
      <div class="form-auto c-alertPos">
        <Button
          variant="main"
          size="w230"
          fsize="f16"
          :disabled="isDisabled || !isEdited"
          :class="{ 'is-loading': isProcessing }"
          @click="submit"
        >
          変更する
        </Button>
        <Alert v-if="hasPutError">
          変更に失敗しました。もう一度クリックしてください
        </Alert>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import DatePicker from '@/components/DatePicker';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: ['project'],
  components: {
    Alert,
    Button,
    DatePicker
  },
  data() {
    return {
      data: {
        publishedDate: null
      },
      params: {
        publishedDate: null
      },
      hasGetError: false,
      hasPutError: false,
      isLoading: true,
      isProcessing: false
    };
  },
  computed: {
    isDisabled() {
      return this.hasGetError || this.isLoading || this.isProcessing;
    },
    isEdited() {
      const oldPublishedDate = this.formatPublishedDate(
        this.data.publishedDate
      );
      const newPublishedDate = this.formatPublishedDate(
        this.params.publishedDate
      );
      return oldPublishedDate !== newPublishedDate;
    }
  },
  created() {
    this.getPublishedDate();
  },
  methods: {
    formatPublishedDate(date) {
      return date ? utils.formatDate(date, 'YYYY-MM-DD') : null;
    },
    getPublishedDate() {
      this.isLoading = true;

      apiProjects.publishedDate
        .get(this.auth.idToken, this.project.id)
        .then(response => {
          if (response.data.publishedDate) {
            this.data.publishedDate = response.data.publishedDate;
            this.params.publishedDate = new Date(response.data.publishedDate);
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.hasGetError = true;
          this.isLoading = false;
        });
    },
    submit() {
      if (this.isDisabled) return;
      this.isProcessing = true;

      const params = {
        publishedDate: this.formatPublishedDate(this.params.publishedDate)
      };

      apiProjects.publishedDate
        .put(params, this.auth.idToken, this.project.id)
        .then(response => {
          this.data.publishedDate = params.publishedDate;
          this.isProcessing = false;
        })
        .catch(error => {
          this.hasPutError = true;
          setTimeout(() => {
            this.hasPutError = false;
          }, 2000);
          this.isProcessing = false;
        });
    }
  }
};
</script>
